export default __webpack_public_path__ + "static/media/logo-footer.91535001.png";